<script setup lang="ts">
const { icon = true } = defineProps<{ item: NavItemProps, icon?: boolean }>()

const { theme } = useTheme()
</script>

<template>
  <component :is="$attrs.is || 'li'">
    <NavDropdown v-if="!!item.childProps" v-bind="item" />
    <Button v-else-if="item.regularButton" v-bind="item" :target="item.external ? '_blank' : undefined" :color="theme">
      <template v-if="!item.srOnly">
        {{ item.label }}
      </template>
    </Button>
    <NavButton v-else v-bind="item" :icon="icon ? item.icon : undefined" />
  </component>
</template>
